import React from 'react';
import PageBanner from '../components/PageBanner';
import CTASection from '../components/CTASection';
import { Shield, BookOpen, Users, Heart } from 'lucide-react';

const PILLARS = [
  { icon: Shield, title: 'Mental Wellbeing', desc: 'Creating safe spaces for boys to express emotion and seek support without stigma.' },
  { icon: BookOpen, title: 'Education & Skills', desc: 'Tutoring, mentorship and vocational programs for at-risk boys in our communities.' },
  { icon: Users, title: 'Positive Role Models', desc: 'Connecting boys with mentors who model integrity, responsibility and kindness.' },
  { icon: Heart, title: 'Healthy Masculinity', desc: 'Workshops promoting respect, empathy and the rejection of gender-based violence.' },
];

const BoyChild = () => (
  <main>
    <PageBanner title="International Boy Child Day" crumb="Boy Child" />

    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="relative h-[480px]">
          <div className="absolute inset-0 overflow-hidden rounded-sm shadow-xl">
            <img src="https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/ez2nox1o_4.jpeg" alt="Boy Child Day" className="w-full h-full object-cover" />
          </div>
        </div>
        <div>
          <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">Raising Awareness</p>
          <h2 className="heading-display text-3xl md:text-5xl font-bold text-slate-900 leading-tight">Building a Better World <span className="text-[#F97559]">For Our Boys.</span></h2>
          <p className="mt-6 text-slate-600 leading-8 text-[15px]">While our primary focus remains on empowering African girls, the Moleboheng Matli Foundation believes that gender equality is a shared journey. International Boy Child Day, observed annually, is our opportunity to spotlight the unique challenges boys face—mental health, education access, exposure to violence—and the role they play in building a safer, more equitable future.</p>
          <p className="mt-4 text-slate-600 leading-8 text-[15px]">Through awareness campaigns, community dialogues and partnerships, we extend a hand to boys who too often feel forgotten in the conversation around child welfare.</p>
        </div>
      </div>
    </section>

    <section className="py-20 md:py-24 bg-slate-50">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12">
          <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">Our Focus Areas</p>
          <h2 className="heading-display text-4xl md:text-5xl font-bold text-slate-900">Four Pillars of Support</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {PILLARS.map((p, i) => (
            <div key={i} className="bg-white p-8 rounded-sm card-lift text-center">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#2BBECF] text-white grid place-items-center"><p.icon size={26} /></div>
              <h3 className="heading-display mt-5 text-xl font-bold text-slate-900">{p.title}</h3>
              <p className="mt-3 text-slate-600 text-sm leading-7">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <CTASection />
  </main>
);

export default BoyChild;
